import { render, staticRenderFns } from "./DynamicSquareView.vue?vue&type=template&id=17db4079&scoped=true"
import script from "./DynamicSquareView.vue?vue&type=script&lang=js"
export * from "./DynamicSquareView.vue?vue&type=script&lang=js"
import style0 from "./DynamicSquareView.vue?vue&type=style&index=0&id=17db4079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17db4079",
  null
  
)

export default component.exports